import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons"
import {
  Button,
  Container,
  FormControl,
  FormErrorMessage,
  Icon,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  // Text,
  useBoolean,
} from "@chakra-ui/react"
import {
  createFileRoute,
  Link as RouterLink,
  redirect,
} from "@tanstack/react-router"
import { type SubmitHandler, useForm } from "react-hook-form"
import type { BodyLoginAccessToken as AccessToken } from "../client"
import useAuth, { isLoggedIn } from "../hooks/useAuth"
import { useCompanyProfile } from "../hooks/useCompanyProfile"
import { emailPattern } from "../utils"

export const Route = createFileRoute("/login")({
  component: Login,
  beforeLoad: async () => {
    if (isLoggedIn()) {
      throw redirect({
        to: "/",
      })
    }
  },
})

function Login() {
  const [show, setShow] = useBoolean()
  const { loginMutation, error, resetError } = useAuth()
  const { profile } = useCompanyProfile()
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<AccessToken>({
    mode: "onBlur",
    criteriaMode: "all",
    defaultValues: {
      email: "",
      password: "",
    },
  })

  const onSubmit: SubmitHandler<AccessToken> = async (data) => {
    if (isSubmitting) return

    resetError()

    try {
      await loginMutation.mutateAsync(data)
    } catch {
      // error is handled by useAuth hook
    }
  }

  return (
    <Container
      as="form"
      onSubmit={handleSubmit(onSubmit)}
      h="100vh"
      maxW="sm"
      alignItems="stretch"
      justifyContent="center"
      gap={4}
      centerContent
    >
      <Image
        src={profile.assets.loginLogo}
        alt={profile.alt.loginLogo}
        height="auto"
        maxW="2xs"
        alignSelf="center"
        mb={4}
      />
      <FormControl id="email" isInvalid={!!errors.email || !!error}>
        <Input
          id="email"
          {...register("email", {
            required: "Email jest wymagany",
            pattern: emailPattern,
          })}
          placeholder="Email"
          type="email"
          required
        />
        {errors.email && (
          <FormErrorMessage>{errors.email.message}</FormErrorMessage>
        )}
      </FormControl>
      <FormControl id="password" isInvalid={!!error}>
        <InputGroup>
          <Input
            {...register("password", {
              required: "Hasło jest wymagane",
            })}
            type={show ? "text" : "password"}
            placeholder="Hasło"
            required
          />
          <InputRightElement
            color="ui.dim"
            _hover={{
              cursor: "pointer",
            }}
          >
            <Icon
              as={show ? ViewOffIcon : ViewIcon}
              onClick={setShow.toggle}
              aria-label={show ? "Hide password" : "Show password"}
            >
              {show ? <ViewOffIcon /> : <ViewIcon />}
            </Icon>
          </InputRightElement>
        </InputGroup>
        {error && <FormErrorMessage>{error}</FormErrorMessage>}
      </FormControl>
      <Link as={RouterLink} to="/recover-password" color="blue.500">
        Forgot password?
      </Link>
      <Button variant="primary" type="submit" isLoading={isSubmitting}>
        Log In
      </Button>
      {/*<Text>*/}
      {/*  Don't have an account?{" "}*/}
      {/*  <Link as={RouterLink} to="/signup" color="blue.500">*/}
      {/*    Sign up*/}
      {/*  </Link>*/}
      {/*</Text>*/}
    </Container>
  )
}
